import { API, axiosInstance } from "lib";

export const uploadBannerFiles = (data = {}) => {
  return axiosInstance
    .post(API.BANNNER_UPLOAD , data, {
      headers: { "Content-Type": "multipart/form-data" },
    })
    .then((response) => {
      return response.data;
    })
    .catch((err) => {
      if (err) {
      }
      throw err;
    });
};
